export const PriceFormatter = (price: number): string => {
    return `$${price.toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };